import { Validator } from './validator';

export class RecaptchaV2Validator implements Validator {

    private isRecaptchaVerifiedCallback: any;

    constructor(isRecaptchaVerifiedCallback: any) {
        this.isRecaptchaVerifiedCallback = isRecaptchaVerifiedCallback;
    }

    validate(): Promise<boolean> {
        const isRecaptchaVerified = this.isRecaptchaVerifiedCallback();
        return Promise.resolve(isRecaptchaVerified);
    }

}
